export { useAuthContext as useAuth } from "../context-providers/auth-provider";
export type { IAuth } from "../context-providers/auth-provider";
